import React from "react";
import "./Eintragungsgegenstand.css";
import Button from "./ui/Button";
import { IconEdit, IconTrash } from "./ui/Icons";
import LoeschungModal from "./LoeschungModal";
import { useRegisterEintragActions } from "../hooks/useRegisterEintragActions";
import { formatDatumOhneZeit, formatDatum, formatBetrag } from "../utils/formatUtils";

const Sicherheiten = ({ entry, onUpdate }) => {
    const grundpfandrechte = entry?.registereintraege?.filter(
        eintrag => eintrag.type === 'Grundpfandrecht'
    ) || [];

    const {
        actionLoading,
        modalOpen,
        modalMode,
        selectedItem,
        handleDeleteClick,
        handleEditClick,
        handleModalConfirm,
        handleModalCancel
    } = useRegisterEintragActions(entry, onUpdate, 'Grundpfandrecht');

    return (
        <div className="common-section">
            {grundpfandrechte.length === 0 ? (
                <p className="no-data">Keine Sicherheiten vorhanden</p>
            ) : (
                <table className="common-table">
                    <thead>
                    <tr>
                        <th>Nr.</th>
                        <th>Aktenzeichen</th>
                        <th>Betrag</th>
                        <th>Umfang</th>
                        <th>Rechtl. Grund</th>
                        <th>Abtretung</th>
                        <th>Eintragung</th>
                        <th>Bemerkungen</th>
                        <th>Aktionen</th>
                    </tr>
                    </thead>
                    <tbody>
                    {grundpfandrechte.map((item, idx) => (
                        <tr
                            key={idx}
                            className={`common-row${idx % 2 === 0 ? ' zebra' : ''}${item.geloescht ? " is-geloescht" : ""}`}
                        >
                            <td>{item.laufendeNr}</td>
                            <td>{item.aktenzeichen}</td>
                            <td>{formatBetrag(item.betrag, item.waehrung)}</td>
                            <td>{formatBetrag(item.umfang, item.waehrung)}</td>
                            <td>{item.rechtlicherGrund}</td>
                            <td>{formatDatumOhneZeit(item.datumRechtlicherGrund)}</td>
                            <td>{formatDatum(item.zeitpunktEintragung)}</td>
                            <td>{item.sonstigeBemerkungen || "-"}</td>
                            <td>
                                <div className="action-buttons">
                                    <Button
                                        variant="primary"
                                        icon
                                        size="sm"
                                        ariaLabel="Eintrag ändern"
                                        title="Eintrag ändern"
                                        tooltip="Eintrag ändern"
                                        tooltipAlign="right"
                                        disabled={actionLoading === item.id || item.geloescht}
                                        onClick={() => handleEditClick(item)}
                                    >
                                        {actionLoading === item.id && modalMode === 'edit' ? (
                                            '⋯'
                                        ) : (
                                            <IconEdit />
                                        )}
                                    </Button>
                                    <Button
                                        variant="danger"
                                        icon
                                        size="sm"
                                        ariaLabel="Eintrag löschen"
                                        title="Eintrag löschen"
                                        tooltip="Eintrag löschen"
                                        tooltipAlign="right"
                                        disabled={actionLoading === item.id || item.geloescht}
                                        onClick={() => handleDeleteClick(item)}
                                    >
                                        {actionLoading === item.id && modalMode === 'delete' ? (
                                            '⋯'
                                        ) : (
                                            <IconTrash />
                                        )}
                                    </Button>
                                </div>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            )}

            <LoeschungModal
                isOpen={modalOpen}
                onClose={handleModalCancel}
                onConfirm={handleModalConfirm}
                item={selectedItem}
                mode={modalMode}
            />
        </div>
    );
};

export default Sicherheiten;
